import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss"
import VueFeather from "vue-feather";
import Breadcrumbs from './layout/breadCrumbs.vue';

import { createI18n } from 'vue-i18n'
import English from "./locales/en.json"
import لعربية from "./locales/ae.json"
import 简体中文 from "./locales/cn.json"
import Português from "./locales/pt.json"
import Français from "./locales/fr.json"
import Deutsch from "./locales/de.json"
import Español from "./locales/es.json"
const i18n = createI18n({
    legacy: false,
    locale: 'English',
    messages: {
        English: English,
        Español: Español,
        Deutsch: Deutsch,
        Français: Français,
        Português: Português,
        简体中文: 简体中文,
        لعربية: لعربية,
    }
})

const app = createApp(App)
app.use(store)
app.use(router)
app.use(i18n)
app.component(VueFeather.name, VueFeather)
app.component('Breadcrumbs', Breadcrumbs)
app.mount('#app')

// Evitar pantalla oscurecida sin modal: quitar backdrops y clase offcanvas que a veces quedan
router.isReady().then(() => {
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())
  document.body.classList.remove('offcanvas', 'modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
})
